module.exports = __webpack_public_path__ + "img/sentra9.1a778d0e.jpeg";